import { render, staticRenderFns } from "./GiftGoalSettingsContent.vue?vue&type=template&id=57fda0b1&scoped=true"
import script from "./GiftGoalSettingsContent.vue?vue&type=script&lang=js"
export * from "./GiftGoalSettingsContent.vue?vue&type=script&lang=js"
import style0 from "./GiftGoalSettingsContent.vue?vue&type=style&index=0&id=57fda0b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fda0b1",
  null
  
)

export default component.exports